<template lang="pug">
  transition(name='fade')
    header(class='c-off-canvas__wrapper', @click.self="$emit('hide')")
      nav(class='c-off-canvas u-overflow-auto u-flex u-flex-column u-justify-between')
        div
          button(class='u-bg-transparent u-border-none u-mb4 u-pl0' @click="$emit('hide')")
            i.u-icon.u-color-secondary.u-fz-h3 menu

          ul(class='u-list-none u-pl0 u-mb0 u-mt0')
            li
              router-link(:to="{ name: 'Home'}" class='c-off-canvas__link' exact) Inicio
            li
              router-link(:to="{ name: 'Operator'}" class='c-off-canvas__link') Trabaja con nosotros
            li
              router-link(:to="{ name: 'Services'}" class='c-off-canvas__link') Servicios
            li
              router-link(:to="{ name: 'About'}" class='c-off-canvas__link') Nosotros
            li
              router-link(:to="{ name: 'Posts'}" class='c-off-canvas__link') Noticias
            li
              router-link(:to="{ name: 'Contact'}" class='c-off-canvas__link') Contáctanos
            li(class='u-mb3 u-text-decoration-none')
              //- router-link(:to="{ name: 'Report'}" class='c-off-canvas__link') Reporta Pavill
              <a href='https://reporta.pavill.com/' :target="hrefTarget"> Reporta Pavill </a>
            li(class='u-mb3')
              router-link(:to="{ name: 'Reserve'}" class='c-off-canvas__link u-fw-s-bold u-uppercase' exact) Reserva ya!

            li
              router-link(:to="{ name: 'App'}"
                class='u-inline-flex u-items-center c-btn--secondary u-fz-h6 u-uppercase u-uppercase u-fw-s-bold u-px4 u-decoration-none') Descargar App

        div
          ul(class='u-mb4 u-pl0 u-list-none u-color-primary')
            li(class='u-mb2 u-fw-s-bold' v-if='company.phone')
              i(class='u-icon u-color-secondary u-mr2') phone
              span {{company.phone}}
            li(class='u-mb2 u-fw-s-bold u-flex' v-if='company.cellphone')
              i(class='u-icon u-color-secondary u-mr2') cellphone
              span {{company.cellphone}}
            li(class='u-mb2 u-fw-s-bold' v-if='company.email')
              i(class='u-icon u-color-secondary u-mr2') message
              span {{company.email}}

          ul(class='u-mt0 u-mb0 u-pl0 u-list-none u-flex u-flex-wrap')
            a(target='_blank' class='c-btn-share c-btn-share--facebook', :href='company.facebookPage', v-if='company.facebookPage')
              i(class='u-icon') facebook
            a(target='_blank' class='c-btn-share c-btn-share--linkedin', :href='company.linkedinPage', v-if='company.linkedinPage')
              i(class='u-icon') linkedin
            a(target='_blank' class='c-btn-share c-btn-share--instagram', :href='company.instagramPage', v-if='company.instagramPage')
              i(class='u-icon') instagram
            a(target='_blank' class='c-btn-share c-btn-share--google', :href='company.googlePage', v-if='company.googlePage')
              i(class='u-icon') youtube
            a(target='_blank' class='c-btn-share c-btn-share--soundcloud', :href='company.soundcloudPage', v-if='company.soundcloudPage')
              i(class='u-icon') soundcloud
            a(target='_blank' class='c-btn-share c-btn-share--vimeo', :href='company.vimeoPage', v-if='company.vimeoPage')
              i(class='u-icon') vimeo
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    beforeCreate () {
      window.$('body').css('overflow-y', 'hidden')
    },

    beforeDestroy () {
      window.$('body').css('overflow-y', '')
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/AppHeaderResponsive.vue